import { render, staticRenderFns } from "./add-mating-ovulation-gestation-whelping-container.vue?vue&type=template&id=bf09f8b2&scoped=true&lang=pug"
import script from "./add-mating-ovulation-gestation-whelping-container.js?vue&type=script&lang=js&external"
export * from "./add-mating-ovulation-gestation-whelping-container.js?vue&type=script&lang=js&external"
import style0 from "./add-mating-ovulation-gestation-whelping-container.vue?vue&type=style&index=0&id=bf09f8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf09f8b2",
  null
  
)

export default component.exports